<bn-loading-overlay></bn-loading-overlay>
<h5>Subscrição de cotas (edição)</h5>
<div class="container mt-3 mx-auto">
  <div class="row d-flex justify-content-end">
    <div *ngIf="!edicao" class="col-auto">
        <button type="button" class="btn btn-primary no-margin" (click)="voltar()"
          ngbTooltip="Retorna à tela anterior">Voltar</button>
    </div>
    <div *ngIf="edicao" class="col-auto">
        <button type="button" class="btn btn-danger no-margin" (click)="cancelarEdicao()"
          ngbTooltip="Cancelar">Cancelar</button>
    </div>
    <div *ngIf="edicao" class="col-auto">
        <button type="button" class="btn btn-primary no-margin" (click)="salvarEdicao()"
          ngbTooltip="Salvar edição">Salvar</button>
    </div>
  </div>
  <div class="row">
    <div class="bn-form-group col-md-6">
      <label for="cotista">Cotista</label>
      <input id="costista" class="form-control" readonly [value]="cotistaSelecionado?.nome">
    </div>
    <div class="bn-form-group col-md-3">
      <label for="cnpj-cotista">CNPJ</label>
      <input id="cnpj-costista" class="form-control" readonly [value]="cotistaSelecionado?.cnpj | bnCnpj">
    </div>
    <div class="bn-form-group col-md-3" style="display: flex; align-items: center; margin-top: 1.5em;" >
      <label-conglomerado-dica  [cotistaSelecionado]="cotistaSelecionado"></label-conglomerado-dica>
    </div>
  </div>
  <form [formGroup]="formEdicaoSubscricao">
    <div class="row">
      <div class="bn-form-group col-md-2">
        <label class="form-label" for="numeroCota">Aporte</label>
        <input id="numeroCota" class="form-control" readonly [value]="subscricao?.numeroCota.padStart(4, '0')">
      </div>
      <div class="bn-form-group col-md-4">
        <label class="form-label" for="valor-aporte">Valor do aporte R$</label>
        <input id="valor-aporte" class="form-control moeda"
          bnMask="MOEDA"
          formControlName="valor">
      </div>
      <div class="bn-form-group col-md-4">
        <label class="form-label" for="data-subscricao">Data da subscrição</label>
        <bn-datepicker id="data-subscricao"
            name="data-subscricao"
            idInput="data-subscricao"
            ngDefaultControl
            formControlName="data"
            [maxDate]="dataHoje">
        </bn-datepicker>
      </div>
      <div class="bn-form-group col-md-2">
        <label class="form-label" for="categoria">Categoria</label>
        <select id="categoria" class="form-select"
          formControlName="categoria">
          <option></option>
          <option *ngFor="let categoria of categorias">{{ categoria }}</option>
        </select>
      </div>
    </div>
  </form>
  <div class="table-responsive">
    <table class="table mt-4">
      <thead class="bg-light">
        <th class="text-start">Aporte</th>
        <th class="text-center">Valor do aporte R$</th>
        <th class="text-center">Data da subscrição</th>
        <th class="text-center">Categoria</th>
        <th *ngIf="podeEditarSubscricao" class="text-start">Ações</th>
      </thead>
      <tbody>
        <tr *ngIf="subscricoes.length === 0">
          <td colspan="5" style="font-style: italic;">
            Nenhuma subscrição adicionada.
          </td>
        </tr>
        <tr *ngFor="let item of subscricoes">
          <td class="col-md-2 text-start">{{ item.numeroCota | numeroAporte }}</td>
          <td class="col-md-4 text-center">{{ item.valor | bnMask: 'MOEDA' }}</td>
          <td class="col-md-2 text-center">{{ item.dataSubscricao | date:'dd/MM/YYYY' }}</td>
          <td class="col-md-2 text-center">{{ item.categoriaCota }}</td>
          <td *ngIf="podeEditarSubscricao" class="col-md-2 text-start" id=col-acoes>
            <a href="javascript:void(0)"
                bnConfirm
                tituloConfirm="Confirmação"
                msgConfirm="Confirma a exclusão da subscrição selecionada?"
                (onConfirm)="remover(item.id)"
                [class]="edicao ? 'disabled-link' : ''"
                ngbTooltip="Excluir a subscrição selecionada">
              <i class="fa fa-trash cursor-pointer text-danger" placement="left-center"
              style="color: #dc4140;"></i>
            </a>
            <a href="javascript:void(0)" class="ms-3" [class]="edicao ? 'disabled-link' : ''" 
            (click)="btnEditarSubscricao(item)" ngbTooltip="Editar a subscrição selecionada">
              <i class="fa fa-pen cursor-pointer text-primary" placement="left-center" 
              style="color: #0078c0;"></i>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div>
    <table class="table">
      <tbody>
        <tr *ngFor="let item of totalSubscricoes" class="fw-bold">
          <div class="row border bg-light text-md-start mt-4"
          style="background-color: #e9ecef;">
            <td class="col-md-3 text-center text-md-start"
            style="border: none;">Total subscrições</td>
            <td class="col-md-3" style="border: none !important;">
              <div class="d-md-flex ms-md-4 text-center text-md-start">
                {{ item.total | bnMask: 'MOEDA' }}
              </div>
            </td>
            <td class="col-md-6 text-center" style="border: none;">{{ item.categoria }}</td>
          </div>
        </tr>
      </tbody>
    </table>
  </div>
</div>
